import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Box, Button, Typography, TextField, InputAdornment, Drawer, IconButton } from "@mui/material";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { updateUserDetails } from "../../../../actions/user";


const AccountDetailsDrawer = ({ open, onClose, item }) => {

    const [formData, setFormData] = useState({
        email: "",
        fullName: "",
        phoneNumber: "",
        joinedDate: "" // Assuming this is locked
    });
    const [errors, setErrors] = useState({
        email: "",
        fullName: "",
        phoneNumber: "",
    });

    useEffect(() => {
        if (item) {
            setFormData({
                email: item.email || "",
                fullName: item.fullName || "",
                phoneNumber: item.phoneNumber || "",
                joinedDate: item.joinedDate ? dayjs(item.joinedDate).format("YYYY-MM-DD") : ""
            });
        }
    }, [item]);

    const validateField = (name, value) => {
        let error = "";

        switch (name) {
            case "email":
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) error = "Invalid email format";
                break;

            case "fullName":
                if (!value.trim()) error = "Required";
                else if (!/^[A-Za-z ]+$/.test(value)) error = "Letters only";
                else if (value.trim().length < 2) error = "Min 2 characters";
                break;

            case "phoneNumber":
                if (!value) error = "Required";
                else if (!/^\d{10}$/.test(value)) error = "10 digits required";
                break;
            default:
                break;
        }

        return error;
    };
    const isFormValid = Object.values(errors).every((error) => !error);

    const handleChange = (e) => {
        const { name, value } = e.target;

        const error = validateField(name, value);
        setErrors({ ...errors, [name]: error });
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let newErrors = {};

        Object.keys(formData).forEach((key) => {
            const error = validateField(key, formData[key]);
            if (error) newErrors[key] = error;
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        const data={
            email: formData.email,
            fullName: formData.fullName,
            phoneNumber: formData.phoneNumber,
        };
        // console.log("data",data)
        // updateUserDetails(item?._id)

        console.log("Form Submitted", formData);
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose} sx={{
            "& .MuiDrawer-paper": {
                top: "0px  !important",
                backgroundColor: "#fafafa"
            },
            "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                top: "0px !important"
            }

        }}>
            <Box sx={{ width: 420, marginX: "auto", marginTop: "25px" }} >
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", }}>
                        <Typography
                            variant="body1"
                            fontWeight="bold"
                            className="sofiaRegular"
                            sx={{ fontSize: "16px", marginBottom: 0 }}
                        >
                            Account Details
                        </Typography>
                        <Typography
                            variant="body2"
                            className="sofiaRegular"
                            sx={{ fontSize: "14px", marginBottom: 0, color: "#000" }}
                        >
                            {item?.email}
                        </Typography>
                    </Box>
                    <Box>
                        <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                            <CancelRoundedIcon />
                        </IconButton>
                    </Box>
                </Box>
                <form onSubmit={handleSubmit}>

                    {/* Form Fields */}

                    <Box sx={{ mt: 5, marginBottom: 2, display: "flex", flexDirection: "column", gap: "20px" }}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Account Holder Email"
                            size="small"
                            className="sofiaRegular"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            sx={inputStyles}
                            error={!!errors.email}
                            helperText={errors.email}
                        />
                        <TextField
                            className="sofiaRegular"
                            fullWidth
                            size="small"
                            variant="outlined"
                            label="Account Holder Name"
                            name="fullName"
                            value={formData.fullName}
                            onChange={handleChange}
                            sx={inputStyles}
                            error={!!errors.fullName}
                            helperText={errors.fullName}
                        />
                        <TextField
                            fullWidth
                            className="sofiaRegular"
                            size="small"
                            variant="outlined"
                            label="Phone Number"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={(e) => {
                                const { name, value } = e.target;
                                // Only allow numbers and limit to 10 digits
                                if (/^\d{0,10}$/.test(value)) {
                                    handleChange(e);
                                }
                            }}
                            sx={inputStyles}
                            error={!!errors.phoneNumber}
                            helperText={errors.phoneNumber}
                            inputProps={{
                                maxLength: 10, inputMode: "numeric",
                                pattern: "[0-9]*",
                            }}
                        />
                    </Box>
                    {/* Locked Date Field */}
                    <Box sx={{ marginBottom: 3 }}>
                        <TextField
                            fullWidth
                            className="sofiaRegular"
                            variant="outlined"
                            placeholder="11/11/2024"
                            label="Joined Date"
                            size="small"
                            name="joinedDate"
                            value={"11/11/2024"}
                            // value={dayjs(formData.joinedDate).format("YYYY-MM-DD")}
                            onChange={handleChange}
                            disabled
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <img
                                            src="/assets/images/user/lock.svg"
                                            alt="Lock Icon"
                                            width="12"
                                        />
                                    </InputAdornment>
                                )
                            }}
                            sx={{
                                ...inputStyles,
                                "& input": {
                                    color: "#000", // Text color
                                    cursor: "not-allowed", // Change cursor to show it's disabled
                                },
                            }}
                        />

                    </Box>

                    {/* Save Button */}
                    <Button
                        fullWidth
                        className="sofiaRegular"
                        variant="contained"
                        type="submit"
                        disabled={!isFormValid}
                        sx={{
                            background: isFormValid ? "#000" : "#ccc",
                            fontFamily: "Sofia Pro, sans-serif !important",
                            color: "#fff",
                            padding: "10px",
                            fontSize: "16px",
                            // lineHeight:"0.9",
                            textTransform: "none",
                            borderRadius: "6px",
                            '&:hover': {
                                background: isFormValid ? "#333" : "#ccc",
                            },
                        }}
                    >
                        Save Account Details
                    </Button>

                </form>
            </Box>
        </Drawer>
    );
};

export default AccountDetailsDrawer



const inputStyles = {
    "& .MuiOutlinedInput-root": {
        fontFamily: "Sofia Pro, sans-serif !important",
        borderRadius: "6px",
        background: "#fff",
        fontSize: "16px",
        borderColor: "#333",
        color: "#191919",
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#333',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#333 !important',
        },
    },
    '& .MuiInputLabel-root': {
        color: '#191919',
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: '#191919 !important', // Change focus color to black
    },
};